
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { amountFormat, getToken } from '../../../helpers/Helper';
import { del, post } from '../../../helpers/api_helper';
import { POST_EMPLOYEE_LIST, DELETE_EMPLOYEE, POST_UPDATE_EMPLOYEE_STATUS } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import ImportEmployees from './../../../components/ImportEmployees';
import { useTranslation } from 'react-i18next';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";



const EmployeeList = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [employeeId, SetemployeeId] = useState(0);


    useMounted(() => {
        getList()
    })

    const getList = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [6,7] },
                    // { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_EMPLOYEE_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                E-{data.employeeId}
                            </>)
                        }
                    },
                    { "data": "employeeCode" },
                    { "data": "name" },
                    { "data": "mobileNumber" },
                    { "data": "gender" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {amountFormat(data.totalBalance)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.employeeStatus !== 'Archive' && <button onClick={UpdateStatus.bind(this, data.employeeId, data.employeeStatus)} className={`border-0 badge ${(data.employeeStatus === 'Active') ? 'bg-success' : 'bg-danger'}`}>{data.employeeStatus}</button>}
                                {data.employeeStatus === 'Archive' && <button className={`border-0 badge bg-danger`}>{data.employeeStatus}</button>}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.employeeStatus !== 'Archive' && <>
                                    <button className="btn btn-sm text-primary mr-2" onClick={() => { navigate('/employees/edit/' + data.employeeId); }} ><i className="bx bx-edit"></i></button>
                                    <button className="btn btn-sm border-0 badge bg-danger" onClick={() => { SetemployeeId(data.employeeId); }} data-bs-toggle="modal" data-bs-target="#archiveModal" >Archive</button>
                                </>}
                                <button className="btn btn-sm text-danger" onClick={() => { SetemployeeId(data.employeeId); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>
                            </>)
                        }
                    },
                ]
            });
        }
    }

    //UpdateStatus
    const UpdateStatus = async (employeeId, status) => {
        
        var res_data = await post(POST_UPDATE_EMPLOYEE_STATUS, { employeeId: employeeId, status: status });
        if (res_data.status) {
            toast(res_data.message);
            getList();
        } else {
            toast.error(res_data.message);
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(DELETE_EMPLOYEE + "?employeeId=" + employeeId);
        if (res_data.status) {
            toast(res_data.message);
            getList();
        } else {
            toast.error(res_data.message);
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>{t('employee.list.title')}</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    <button type='button' data-bs-toggle="modal" data-bs-target="#ImportEmployees" className='btn btn-sm btn-primary me-3'>+ {t('employee.list.import')}</button>
                                    <Link to='/employees/add' className='btn btn-sm btn-primary'>+ {t('add')}</Link>
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>{t('employee.list.employeeId')}</td>
                                            <td>{t('employee.list.employeeCode')}</td>
                                            <td>{t('employee.list.name')}</td>
                                            <td>{t('employee.list.mobileNumber')}</td>
                                            <td>{t('employee.list.gender')}</td>
                                            <td>{t('employee.list.totalBalance')}</td>
                                            <td>{t('employee.list.status')}</td>
                                            <td>{t('employee.list.action')}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t('delete.title')}</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className='mb-0'>{t('employee.list.deleteMessage')}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t('delete.no')}</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">{t('delete.yes')}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="archiveModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t('employee.list.archiveTitle')}</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className='mb-0'>{t('employee.list.archiveMessage')}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t('delete.no')}</button>
                            <button onClick={() => {UpdateStatus(employeeId,'Archive')}} data-bs-dismiss="modal" className="btn btn-primary">{t('delete.yes')}</button>
                        </div>
                    </div>
                </div>
            </div>

            <ImportEmployees call_back={() => {getList()}} />
        </>
    );
}

export default EmployeeList;